<template>
  <v-container class="mt-3">
    <v-card>
      <v-card-title
        ><h1 class="text-h6 font-weight-bold ma-0">
          Meta Resume Guide: How to Stand Out for Facebook, Instagram &amp;
          WhatsApp Roles
        </h1></v-card-title
      >
      <v-card-text>
        <resume-cta-banner />
        <v-row>
          <v-col cols="12">
            Meta's culture famously runs on "move fast" and impact — and its
            resume screens reflect that. Recruiters are looking for evidence
            that you can identify a problem, ship a solution, and measure the
            result, often with less process and more autonomy than at other
            large tech companies.
          </v-col>
        </v-row>

        <h2 class="text-h6 mt-4 mb-2">
          1. Impact Is the Single Biggest Signal
        </h2>
        <p>
          Meta's internal performance framework is built almost entirely around
          measurable impact, and resume screens mirror that. Every bullet should
          answer "so what happened because of this?" — user growth, engagement,
          revenue, latency, cost, or reliability.
        </p>
        <ul>
          <li>
            <strong>Weak:</strong> "Built a new onboarding flow for the app."
          </li>
          <li>
            <strong>Strong:</strong> "Shipped a redesigned onboarding flow that
            increased Day-7 retention by 12% across 4M new users."
          </li>
        </ul>

        <h2 class="text-h6 mt-4 mb-2">2. Highlight Speed and Autonomy</h2>
        <p>
          Meta values people who can move from idea to shipped product quickly
          with minimal oversight. If you drove a project end-to-end — from
          scoping through launch — say so explicitly, including timeline
          ("shipped in 6 weeks").
        </p>

        <h2 class="text-h6 mt-4 mb-2">3. Cross-Functional Work Matters</h2>
        <p>
          Meta teams are typically small, cross-functional pods of engineers,
          designers, data scientists, and product managers. Resumes that show
          you working directly with other disciplines — not just handing off
          work — tend to stand out, especially for product-facing roles.
        </p>

        <h2 class="text-h6 mt-4 mb-2">
          4. For Product and Growth Roles, Lead With Metrics Fluency
        </h2>
        <p>
          If you're applying for product, growth, or data-adjacent roles, show
          you think in metrics: north-star metrics, A/B test results, funnel
          conversion, retention curves. Meta's product culture is deeply
          metrics-driven, and your resume should demonstrate that instinct
          before the interview even starts.
        </p>

        <h2 class="text-h6 mt-4 mb-2">5. Engineering Roles: Show Scale</h2>
        <p>
          Meta's products run at massive scale — billions of users across
          Facebook, Instagram, and WhatsApp. Where relevant, mention the scale
          you've worked at (requests per second, data volume, number of users
          affected) even if it's smaller than Meta's own scale; it signals you
          understand the constraints of building at scale.
        </p>

        <h2 class="text-h6 mt-4 mb-2">6. Keep It Concise and Skimmable</h2>
        <p>
          Recruiters and hiring managers move through a high volume of
          applications. A tight, one-to-two-page resume with clear section
          headers and quantified bullets will get read more carefully than a
          dense, unstructured one.
        </p>

        <v-alert type="info" outlined class="mt-4">
          Tip: Check out our
          <router-link to="/faang-resume-guide">FAANG resume guide</router-link>
          for patterns that apply across top tech employers, our
          <router-link to="/google-resume-guide">Google</router-link>
          and
          <router-link to="/amazon-resume-guide">Amazon</router-link>
          guides if you're also applying there, or our
          <router-link to="/tech-startup-resume-guide"
            >tech startup resume guide</router-link
          >
          if you're weighing a smaller company instead.
        </v-alert>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import ResumeCtaBanner from "../../components/ResumeCtaBanner.vue";

export default {
  name: "MetaResumeGuide",
  components: { ResumeCtaBanner },
  mounted() {
    this.$utils.visit(this);
  },
};
</script>
